var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-32325d76-d4e8-467d-82c9-185ada5a8af3",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-157be5ff-8d31-471e-9cbf-b1e4f81660c6 {\r\n        fill: #f74f56;\r\n        filter: url(#uuid-34ebf4a3-d216-4f5e-8336-f67fdd406d4c);\r\n      }\r\n\r\n      .uuid-98c0c626-a41e-4b7b-b6b3-aece5223e8cc {\r\n        fill: #fff;\r\n      }\r\n\r\n      .uuid-9b1d972c-ac56-49f6-9f92-d3b2bb53ddb9 {\r\n        filter: url(#uuid-ed09e5d5-edac-40ae-aaf8-4ff4025bdf95);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "uuid-34ebf4a3-d216-4f5e-8336-f67fdd406d4c",
    "data-name": "drop-shadow-1",
    x: 38,
    y: -40,
    width: 1004,
    height: 1980,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "uuid-0715ff45-84c9-49bc-82a5-819cc0c95833",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "uuid-0715ff45-84c9-49bc-82a5-819cc0c95833",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "uuid-ed09e5d5-edac-40ae-aaf8-4ff4025bdf95",
    "data-name": "drop-shadow-2",
    x: 247,
    y: 759,
    width: 579,
    height: 545,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "uuid-71ff67c7-312b-477b-8011-fd3391dfc2bb",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "uuid-71ff67c7-312b-477b-8011-fd3391dfc2bb",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-157be5ff-8d31-471e-9cbf-b1e4f81660c6",
    d: "M981.24,1021.33c0-152.04-76.9-286.1-193.93-365.45V0h-494.62v655.88c-117.02,79.35-193.93,213.41-193.93,365.45s76.9,286.1,193.93,365.45v454.53c0,17.89,23.21,24.9,33.11,10.01l214.2-322.11,214.2,322.11c9.91,14.9,33.11,7.89,33.11-10.01v-454.53c117.02-79.35,193.93-213.41,193.93-365.45Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "uuid-9b1d972c-ac56-49f6-9f92-d3b2bb53ddb9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-98c0c626-a41e-4b7b-b6b3-aece5223e8cc",
    d: "M440.47,1263.4h-.75c-7.62-.28-14.65-4.18-18.87-10.52l-139.09-209.75c-7.18-10.85-4.23-25.41,6.61-32.63,10.81-7.08,25.45-4.23,32.62,6.62l120.77,182.13,311.48-410.68c7.87-10.34,22.6-12.36,32.97-4.55,10.35,7.86,12.37,22.61,4.53,32.95l-331.52,437.1c-4.46,5.88-11.4,9.33-18.75,9.33Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCheck);
export default __webpack_public_path__ + "static/media/RedCheck.2ae7733780a7dd0278f4b7a102636cb6.svg";
export { ForwardRef as ReactComponent };